/* Kendo grid view html cell (render html content) */

import * as _ from 'lodash';
import * as React from 'react';

import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { Formatters } from '../common/formatters';

export default class CellHtml extends React.Component<any, any> {
    public render() {
        const { dataItem, field, recordEditingField, handleInputChange, ...rest } = this.props;

        const cellHtmlContent = Formatters.getStr(dataItem, field);

        const isEditing = Formatters.getBool(dataItem, recordEditingField);

        let result = (<td />);
        if (cellHtmlContent && cellHtmlContent !== '') {
            const cellHtml = cellHtmlContent.replace(/style="[^"]*"/g, '');

            const inputPropsHtmlEditor = _.merge({}, {
                colLabelXs: 12,
                colInputXs: 12,
                className: 'inventory-detail-input-full-width',
            });

            result = (isEditing) ? (
                <td className="lookup-tables-table-user-resume-cell-html-edit">
                    <div className="lookup-tables-table-user-resume-html-container">
                        <KendoWrappers.KendoHtmlEditor
                            name="resume"
                            label=""
                            defaultValue={cellHtml}
                            onChange={handleInputChange}
                            {...inputPropsHtmlEditor}
                        />
                    </div>
                </td>
            ) : (
                <td className="lookup-tables-table-user-resume-cell-html-view">
                    <div className="lookup-tables-table-user-resume-html-container" dangerouslySetInnerHTML={{__html: cellHtml}} />
                </td>
            );
        }

        return result;
    }

    public handleChange(e: any) {
        const { dataItem, recordEditingField, ...rest } = this.props;

        this.props.handleInputChange({ e });
    }
}



// WEBPACK FOOTER //
// ./src/lookup-tables/cell-html.tsx